import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { QuickFilter } from './model/quick-filter.model';

@Component({
  template: '',
})
export class UsfFilteringBannerComponent {
  @Input() numberOfSelectedFilters;
  @Input() filterDateRange: string;
  @Input() isLoading = true;
  @Input() quickFilters: QuickFilter[] = [];
  @Input() showQuickDateFilterOption = false;
  @Input() showResetFilterOption = false;
  @Input() showFilterModalButton = true;
  @Input() showViewTodaysOrdersButton = false;
  @Input() showDateRange = false;
  @Input() showShareDownloadButton = false;
  @Input() resetLabel = false;
  @ViewChild('filterContainer', { static: false }) filterContainer: ElementRef;
  @Output() changeDateFilterClicked: EventEmitter<void> = new EventEmitter();
  @Output() filterClicked: EventEmitter<void> = new EventEmitter();
  @Output() quickFiltersClicked: EventEmitter<QuickFilter> = new EventEmitter();
  @Output() resetFiltersClicked: EventEmitter<void> = new EventEmitter();
  @Output() viewTodaysOrdersClicked: EventEmitter<void> = new EventEmitter();
  @Output() shareDownloadClicked: EventEmitter<void> = new EventEmitter();

  constructor() {}

  openFilterModal() {
    this.filterClicked.emit();
  }

  toggleStatusFilter(quickFilter, index: number) {
    this.scrollToSingleFilter(index);
    this.quickFiltersClicked.emit(quickFilter);
  }

  changeDateButtonClicked() {
    this.changeDateFilterClicked.emit();
  }

  resetFilters() {
    this.resetFiltersClicked.emit();
  }

  getTodaysOrders() {
    this.viewTodaysOrdersClicked.emit();
  }

  shareDownload() {
    this.shareDownloadClicked.emit();
  }

  scrollToSingleFilter(index: number) {
    const containerElement = this.filterContainer?.nativeElement;
    if (!containerElement) return;

    containerElement.classList.toggle('add-bounce');

    const quickFilters = containerElement.querySelectorAll(
      '.single-filter',
    ) as NodeListOf<HTMLElement>;

    const quickFilter = quickFilters[index];
    if (!quickFilter) return;

    containerElement.scrollTo({
      left: quickFilter.offsetLeft - 50,
      behavior: 'smooth',
    });

    setTimeout(() => {
      if (containerElement) {
        containerElement.classList.remove('add-bounce');
      }
    }, 500);
  }
}
